import parallel from 'async/parallel'
riot.tag2('optionitem-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Карточка элемента</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-5">\n            <div class="form-group">\n              <div class="well well-sm">\n                <image-select name="image" section="options" alt="0" size="256" value="{item.image}"></image-select>\n              </div>\n            </div>\n          </div>\n          <div class="col-md-7">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" type="text" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <textarea class="form-control" name="description" value="{item.description}"></textarea>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Цена/%</label>\n              <input class="form-control" name="price" type="text" value="{item.price}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Опция</label>\n              <select class="form-control" name="idOption" value="{item.idOption}">\n                <option each="{group in options}" __selected="{item.idOption == group.id}" value="{group.id}">{group.name}</option>\n              </select>\n            </div>\n            <div class="form-group">\n              <div class="checkbox">\n                <label>\n                  <input type="checkbox" name="isActive" __checked="{item.isActive}">Отображать в магазине\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.cannotBeClosed = true;
    modal.eChange = false;

    //let filters = []

    modal.mixin('validation');
    modal.mixin('change');

    modal.item = {};

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };

    if (opts.item) {
        modal.item = opts.item;
    } else {
        modal.item.idOption = opts.option || 0;
    }

    modal.loader = true;

    modal.getOptionGroup = function () {
        API.request({
            object: 'Option',
            method: 'Fetch',
            success: function success(response) {
                modal.options = response.items;
                if (!modal.item.idOption) {
                    modal.options.forEach(function (item) {
                        modal.item.idOption = item.id;
                        return true;
                    });
                }
                modal.loader = false;
                modal.update();
            }
        });
    };
    modal.getOptionGroup();
});
});


// WEBPACK FOOTER //
// ./pages/products/options/optionitem-edit-modal.tag